/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface IGenericPromptModalResult {
        answer: string;
    }

    export interface IGenericPromptModalScope extends ng.IScope {
        title: string;
        description: string;
        inputName: string;
        inputRequired: boolean;
        inputValue: string;
        modalClose: () => void;
        modalSave: () => void;
    }

    /**
     * GenericPromptModalController class
     */
    export class GenericPromptModalController {
        public static templateUrl: string = "decorators/modals/generic-prompt-modal.html";
        public static id: string = "#id-generic-prompt-modal";
        public static $name: string = "genericPromptModalController";
        public static $inject: string[] = ['$scope',
                                           'close',
                                           '$timeout',
                                           'title',
                                           'description',
                                           'inputName',
                                           'inputRequired',
                                           'inputValue'];

        private $scope: IGenericPromptModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;

        /**
         * Constructor
         */
        constructor($scope: IGenericPromptModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    $timeout: ng.ITimeoutService,
                    title: string,
                    description: string,
                    inputName: string,
                    inputRequired: boolean,
                    inputValue: string) {

            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);

            this.$scope = $scope;
            this.close = close;
            this.$scope.title = title;
            this.$scope.description = description;
            this.$scope.inputName = inputName;
            this.$scope.inputRequired = inputRequired;
            this.$scope.inputValue = inputValue;

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (): void => {
                if (this.$scope.inputRequired) {
                    if (this.$scope.inputValue !== undefined && this.$scope.inputValue !== '')
                        this.close({answer: this.$scope.inputValue});
                } else {
                    this.close({answer: this.$scope.inputValue});
                }
            };
        }
    }
}
